import React, { useEffect, useState } from 'react';
import api from '../services/api';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useNavigate } from 'react-router-dom';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem, Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import { LiaAngleDoubleUpSolid } from 'react-icons/lia';
import '../styles/floatingForm.css'
import gsap from 'gsap';

const CreateMainPageInPage = ({setShowCreateDisplayPage, containerRef}) => {
  const navigate = useNavigate();
    const [subpages, setSubpages] = useState([]);
    const [selectedSubpage, setSelectedSubpage] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [image1, setImage1] = useState(null);
    const [image2, setImage2] = useState(null);
    const [errors, setErrors] = useState({});
  
    const validateImageDimensions = (file, maxWidth, maxHeight) => {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => {
          if (image.width <= maxWidth && image.height <= maxHeight) {
            resolve(true);
          } else {
            resolve(false);
          }
        };
        image.onerror = () => {
          reject(new Error('Invalid image file'));
        }
        image.src = URL.createObjectURL(file);
      })
    };
  
    useEffect(() => {
      const fetchSubpages = async () => {
        try {
          const response = await api.get('/subpageapi/get-all');
          setSubpages(response.data.data);
        } catch (error) {
          console.error('Error fetching subpages:', error);
          alert('Failed to fetch subpages');
        }
      };
  
      fetchSubpages();
    }, []);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      let errors = {};
  
      if (!selectedSubpage) errors.selectedSubpage = 'select subpage';
      if (!title.trim()) errors.title = 'title cannot be empty'
      if (!description.trim()) errors.description = 'description cannot be empty';
  
      const allowedImageTypes = ['image/png', 'image/jpeg'];
      if (!image1) {
        errors.image1 = 'image1 cannot be empty, only PNG and JPG files are allowed';
      } else if (!allowedImageTypes.includes(image1.type)) {
        errors.image1 = 'Only PNG and JPG files are allowed';
      } else {
        const isValidImage = await validateImageDimensions(image1, 1200, 630);
        if (!isValidImage) {
          errors.image1 = 'Image1 must be under 1200px by 630px';
        }
      }
      if (!image2) {
        errors.image2 = 'image2 cannot be empty, only PNG and JPG files are allowed';
      } else if (!allowedImageTypes.includes(image2.type)) {
        errors.image2 = 'Only PNG and JPG files are allowed';
      } else {
        const isValidImage = await validateImageDimensions(image2, 1200, 630);
        if (!isValidImage) {
          errors.image2 = 'Image2 must be under 1200px by 630px';
        }
      }
  
      if (Object.keys(errors).length > 0) {
        setErrors(errors);
        return;
      }
  
      setErrors({});
  
      const formData = new FormData();
      formData.append('title', title);
      formData.append('description', description);
      formData.append('subpage_id', selectedSubpage);
      if (image1) formData.append('image1', image1);
      if (image2) formData.append('image2', image2);
  
      try {
        const response = await api.post('/pagedetail/add', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
  
        if (response.data.status === "success") {
            toast.success(`Mainpage '${response.data.message}' created successfully!`);
            // navigate('/display-pages');
            handleCancel();
        } else {
          toast.error('Failed to create mainpage. Please try again.');
        }
      } catch (error) {
        console.error('Error creating mainpage:', error);
        toast.error('Error creating mainpage');
      }
    };
  
    const handleCancel = () => {
      setTitle('');
      setDescription('');
      setSelectedSubpage('');
      setImage1(null);
      setImage2(null);
      // navigate('/display-pages');
      
      setShowCreateDisplayPage(false);
    };

  return (
    <div className='floating-form-container' ref={containerRef} >
      <div className="heading">
        <h2>Mainpage List</h2>
      </div>

        <form onSubmit={handleSubmit}>
            <div className="form-container">

                <div className="section-1">
                    <div className="input-container-floating-form wid-50">
                        <label>Select Subpage *</label>
                        <select className={`form-control ${errors.selectedSubpage ? 'is-invalid' : ''}`} value={selectedSubpage} onChange={(e) => setSelectedSubpage(e.target.value)}  >
                  <option value="">Select Subpage</option>
                  {subpages.map((subpage) => (
                    <option key={subpage.id} value={subpage.id}>
                      {subpage.subpage}
                    </option>
                  ))}
                </select>
                <b>{errors.selectedSubpage && <span className='text-danger small'>{errors.selectedSubpage}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="title">Title *</label>
                        <input type="text" id="title" className={`form-control ${errors.title ? 'is-invalid' : ''}`} value={title} onChange={(e) => setTitle(e.target.value)} />
                <b>{errors.title && <span className='text-danger small'>{errors.title}</span>}</b>
                    </div>

                    <div className="input-container-floating-form wid-100">
                        <label htmlFor="aboutUs">Page Description *</label>
                        
                        <ReactQuill value={description} onChange={setDescription} className={`react-quill ${errors.description ? 'is-invalid' : ''}`} placeholder="Enter Description" />
                        <b>{errors.description && <span className='text-danger small'>{errors.description}</span>}</b>
                    </div>
                </div>

                <hr className='form-rule' />

                <div className="section-1">

                    <h2 className='wid-100'>Upload Image</h2>

                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="logo">Upload Image 1 * <br /> (only png and Jpg size 1200px*630px)</label>
                        
                        <div class="file-select">
                            <div class="file-select-button" id="fileName">Choose File</div>
                            <div class="file-select-name" id="noFile">{image1?.name || "No file chosen..."}</div> 
                            <input type="file" id="logo" onChange={(e) => setImage1(e.target.files[0])} />
                        </div>
                            <b>{errors.image1 && <span className='text-danger small'>{errors.image1}</span>}</b>

                    </div>
                    <div className="input-container-floating-form wid-50">
                        <label htmlFor="banner">Upload Image 2 * <br /> (only png and Jpg size 1200px*630px)</label>
                        
                        <div class="file-select">
                            <div class="file-select-button" >Choose File</div>
                            <div class="file-select-name" >{image2?.name || "No file chosen..."}</div> 
                            <input type="file" id="banner" onChange={(e) => setImage2(e.target.files[0])} />
                        </div>
                            <b>{errors.image2 && <span className='text-danger small'>{errors.image2}</span>}</b>

                    </div>
                </div>

            </div>

            <div className="form-btn-container">

                <button type='submit'>Create</button>
                <button type='reset' onClick={handleCancel}>Cancel</button>

            </div>


        </form>

    </div>
  );
};

export default CreateMainPageInPage;
